<div class="content-holder">
  <div class="content">
    <!--    <mat-divider></mat-divider>-->
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div class="">
      <router-outlet></router-outlet>
    </div>
  </div>
  <!-- <div class="version faded">
    &copy; {{ currentYear }} - Designed and Developed By eGA
  </div> -->
</div>
